import { LinkButton } from "@/ui/next/LinkButton";
import { useTranslation } from "next-i18next";

import { analyticsService } from "@/common/services/analytics/analytics.service";
import { FOR_YOU_ROUTE } from "@/common/static/routes.static";
import { useHomepageForYouProducts } from "@/components/Homepage/hooks/useHomepageForYouProducts.hooks";
import { ProductCard } from "@/features/search/components/product-card/ProductCard";
import { toCardProduct } from "@/features/search/utils/gateway-product.utils";
import { Heading } from "@/ui/cva/Heading";

const LIST_NAME = "homepage-for-you";

export const HomepageForYouBlock = () => {
  const { t } = useTranslation();
  const { products, searchMeta, hidden } = useHomepageForYouProducts();

  if (hidden) {
    return null;
  }

  return (
    <section className="flex flex-col items-center space-y-6">
      <div className="flex flex-col items-center">
        <Heading as="h2" size="h3" className="text-center">
          {t("homepage:homepage-for-you-title")}
        </Heading>
        <LinkButton
          href={FOR_YOU_ROUTE}
          appearance="minimal"
          onClick={() => analyticsService.trackHpForYou("link")}
        >
          {t("homepage:homepage-for-you-block-link")}
        </LinkButton>
      </div>
      {/* Mobile: horizontal snap scroller showing about 2.5 cards. md: 3 columns (2 even rows of 3). lg: 1 row of 6. */}
      <div className="-mx-4 flex w-[calc(100%+2rem)] snap-x snap-mandatory gap-3 overflow-x-auto px-4 md:mx-0 md:grid md:w-full md:snap-none md:grid-cols-3 md:overflow-visible md:px-0 lg:grid-cols-6">
        {products.map((product, index) => (
          <ProductCard
            key={product.id}
            product={toCardProduct(product)}
            compact
            className="w-[40%] shrink-0 snap-start md:w-auto"
            onSelect={() => {
              analyticsService.trackSelectItem(
                index + 1,
                LIST_NAME,
                LIST_NAME,
                product,
                searchMeta
              );
              analyticsService.trackHpForYou("tile");
            }}
          />
        ))}
      </div>
    </section>
  );
};
